import { trackEvent } from 'tracking/tracking';
import { CreateReferencesMethod } from './actions';

type OpenPanelSource = 'contextMenu' | 'toolbar';
type TripleFilterType = 'componentType' | 'referenceType';

const trackOpenPanel = (source: OpenPanelSource) =>
  trackEvent('Create references panel0 Opened panel', { source });

const trackUseSearchBar = () =>
  trackEvent('Create references panel0 Search bar used');

const trackUseComponentSearch = () =>
  trackEvent('Create references panel0 Component search used');

const trackSelectReferenceType = () =>
  trackEvent('Create references panel0 Reference type selected');

const trackToggleReferenceTypeExpansion = () =>
  trackEvent('Create references panel0 Reference type expansion toggled');

const trackToggleShowAllTriples = () =>
  trackEvent('Create references panel0 Out-of-view reference types toggled');

const trackFilterReferenceList = (filterType: TripleFilterType) =>
  trackEvent('Create references panel0 Reference list filtered', {
    filterType,
  });

const trackApplyAdvancedSearch = () =>
  trackEvent('Create references panel0 Advanced search query applied');

const trackStartCreateNewComponent = () =>
  trackEvent('Create references panel0 Create new component started');

const trackCreatedReferences = ({
  count,
  createdNewComponent,
  method,
}: {
  count: number;
  createdNewComponent: boolean;
  method: CreateReferencesMethod;
}) =>
  trackEvent('Create references panel0 References created', {
    count,
    createdNewComponent,
    method,
  });

const trackReferenceCreationFailed = (method: CreateReferencesMethod) =>
  trackEvent('Create references panel0 Reference creation failed', { method });

const trackClosePanel = () =>
  trackEvent('Create references panel0 Panel closed');

const trackOpenReferenceTypesSettings = () =>
  trackEvent('Create references panel0 Reference types settings opened');

export const createReferencesTracking = {
  trackOpenPanel,
  trackUseSearchBar,
  trackUseComponentSearch,
  trackSelectReferenceType,
  trackToggleReferenceTypeExpansion,
  trackToggleShowAllTriples,
  trackFilterReferenceList,
  trackApplyAdvancedSearch,
  trackStartCreateNewComponent,
  trackCreatedReferences,
  trackReferenceCreationFailed,
  trackClosePanel,
  trackOpenReferenceTypesSettings,
};
